







import Header from '@/views/organisms/Header.vue'

export default
  name: 'Main'

  components: {
    Header
  }

